import { ModuleWithProviders, NgModule } from '@angular/core';
import { MathDirective } from './math.directive';
import { MathServiceImpl } from './math.service';

declare global { interface Window { MathJax: any; } }

@NgModule({
  declarations: [MathDirective],
  exports: [MathDirective]
})
export class MathModule {
  constructor(mathService: MathServiceImpl) {
    if (document.getElementById('mjx-script')) return;

    (window as any).MathJax = {
      tex: {
        inlineMath: [['$', '$'], ['\\(', '\\)']],
        displayMath: [['$$', '$$']],
        processEscapes: true
      },
      startup: { typeset: false }
    };

    const script = document.createElement('script');
    script.id = 'mjx-script';
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdn.jsdelivr.net/npm/mathjax@4/tex-mml-chtml.js';

    script.onload = () => {
      const MJ = (window as any).MathJax;

      MJ.startup.promise
        .then(async () => {
          await MJ.typesetPromise();

          let busy = false;
          setInterval(async () => {
            if (busy) return;
            if (typeof MJ?.typesetPromise !== 'function') return;
            try {
              busy = true;
              await MJ.typesetPromise();
            } catch (e) {
              console.error('MathJax periodic typeset failed', e);
            } finally {
              busy = false;
            }
          }, 5000);
        })
        .catch(console.error);
    };

    document.head.appendChild(script);
  }

  static forRoot(): ModuleWithProviders<MathModule> {
    return { ngModule: MathModule, providers: [{ provide: MathServiceImpl, useClass: MathServiceImpl }] };
  }
}
